import styled from '@emotion/styled'
import React from 'react'
import { useMediaQuery } from 'react-responsive'

const H2 = styled.h2<{
  isBold: boolean
  color?: string
  isMobile: boolean
  mobileTitleVersion: number
  whiteSpace: boolean
}>`
  color: ${(props) => (props.color ? props.color : '#F9F9FB')};
  font-size: ${(props) => {
    if (props.isMobile) {
      if (props.mobileTitleVersion === 1) {
        return '32px'
      }
      return '20px'
    }
    return '36px'
  }};

  font-weight: ${(props) => (props.isBold ? '700' : '400')};
  line-height: 160%;
  word-break: ${(props) => (props.whiteSpace ? 'normal' : 'keep-all')};
  white-space: ${(props) => (props.whiteSpace ? 'pre-wrap' : 'normal')};
  @media screen and (min-width: 1100px) {
    word-break: normal;
    white-space: pre;
  }
`

const TitleText = ({
  text = '',
  isBold = true,
  color = '',

  mobileTitleVersion = 1,
  whiteSpace = true,
}: {
  text: string
  isBold?: boolean
  color?: string

  mobileTitleVersion?: 1 | 2
  whiteSpace?: boolean
}) => {
  const isMobile = useMediaQuery({ query: '(max-width:1099px)' })

  return (
    <H2
      isBold={isBold}
      color={color}
      isMobile={isMobile}
      mobileTitleVersion={mobileTitleVersion}
      whiteSpace={whiteSpace}
    >
      {text}
    </H2>
  )
}

export default TitleText
